import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-group d-flex align-items-center" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatRoomInput',
  emits: ["handleSend"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const message = ref("");

function handleSend() {
  emit("handleSend", message.value);
  message.value = "";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      onKeyup: _withKeys(handleSend, ["enter"]),
      type: "text",
      class: "form-control rounded-pill",
      placeholder: "Digite sua mensagem...",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event))
    }, null, 544), [
      [
        _vModelText,
        message.value,
        void 0,
        { trim: true }
      ]
    ]),
    _createElementVNode("i", {
      class: _normalizeClass([{
        'text-primary': message.value.length > 0,
        'text-primary50': message.value.length == 0,
      }, "fa-solid fa-circle-arrow-up position-absolute end-0 me-3 display-5 cursor-pointer"]),
      onClick: handleSend,
      style: {"z-index":"99"}
    }, null, 2)
  ]))
}
}

})